import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.field_index_page_fields_list', () => {
  void import('./internal/field_index_page_fields_list')
    .then(({ default: Component }) => Component());
});
